export default __webpack_public_path__ + "14d24ded3d34af2aef1e99093c0d292c.png";